export interface FloorPlanDateRangeDTO {
    startDate: string  // ISO date string YYYY-MM-DD
    endDate: string    // ISO date string YYYY-MM-DD
}

export class FloorPlanDTO {

    constructor(
        public id: string,
        public displayName: string,
        public dateRanges: FloorPlanDateRangeDTO[],
        public tableIds: string[],
        public dateCreated: string,
        public dateUpdated: string
    ) { }
}

export class CreateFloorPlanDTO {

    constructor(
        public displayName: string,
        public dateRanges: FloorPlanDateRangeDTO[],
        public tableIds: string[]
    ) { }
}

export class UpdateFloorPlanDTO {

    constructor(
        public displayName?: string,
        public dateRanges?: FloorPlanDateRangeDTO[],
        public tableIds?: string[]
    ) { }
}
